import clsx from "clsx";

const PALETTE = [
  "bg-brand-100 text-brand-700 ring-brand-200",
  "bg-success-100 text-success-700 ring-success-200",
  "bg-warning-100 text-warning-700 ring-warning-200",
  "bg-danger-100 text-danger-700 ring-danger-200",
  "bg-surface-200 text-surface-700 ring-surface-300",
];

export function GenerationBadge({ gen }: { gen: number }) {
  const c = PALETTE[(gen - 1) % PALETTE.length];
  return (
    <span className={clsx(
      "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-2xs font-bold uppercase tracking-wide ring-1 ring-inset",
      c,
    )}>
      Gen {gen}
    </span>
  );
}
